import { render } from "./InfoHistoryKapal.vue?vue&type=template&id=cb0dc6e6"
import script from "./InfoHistoryKapal.vue?vue&type=script&lang=js"
export * from "./InfoHistoryKapal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__